export const GET_LEDGER_START = "[LEDGER] START GET ALL LEDGER";
export const GET_LEDGER_SUCCESS = "[LEDGER] GET ALL LEDGER SUCCESS";
export const GET_LEDGER_FAILURE = "[LEDGER] GET ALL LEDGER FAILURE";
